<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <!-- {{ enquate_type_list }} -->
    <div class="position-relative" style="z-index: 10">
      <div class="w100 mb-5">
        <div class="row mb-3">
          <div class="col-7">
            <label for="Label" class="form-label">名称</label>
            <input
              type="text"
              class="form-control"
              id="Label"
              placeholder="名称"
              v-model="enquate_sheet_obj.label"
            />
          </div>
          <div class="col-2 d-none">
            <label for="Sort" class="form-label">sort</label>
            <input
              type="number"
              class="form-control"
              id="Sort"
              placeholder="ソート"
              v-model="enquate_sheet_obj.sort"
            />
          </div>
        </div>
      </div>
      <div class="w100 mb-5">
        <div class="row mb-2">
          <div class="col-10">
            <h5>設問設定</h5>
          </div>
          <div class="col-2">
            <div class="d-grid">
              <button
                @click="add_enquate"
                class="btn btn-light btn-outline-secondary"
              >
                <i class="bi bi-plus"></i>&nbsp;設問追加
              </button>
            </div>
          </div>
        </div>
        <div
          class="row mb-2"
          v-if="((enquate_sheet_obj || {}).enquate_data || {}).length > 0"
        >
          <div class="col-1">No.</div>
          <div class="col-7">設問文</div>
          <div class="col-2">種別</div>
          <div class="col-1"></div>
          <div class="col-1">削除</div>
        </div>
        <div
          class="row mb-2 border-bottom pb-2"
          v-for="(enquate, index) in (enquate_sheet_obj || {}).enquate_data"
          :key="enquate"
        >
          <div class="col-1">{{ index + 1 }}</div>
          <div class="col-6">
            <input type="text" v-model="enquate.label" class="form-control" />
          </div>
          <div class="col-1">
            <input type="number" v-model="enquate.sort" class="form-control" />
          </div>
          <div class="col-2">
            <bs-select
              :options="enquate_type_label_list"
              v-model="enquate.enquate_type"
              :null-option="false"
              :id="'EnquateType_' + index"
              :classParam="'form-select'"
            ></bs-select>
          </div>
          <div class="col-1">
            <div class="d-none">
              <button @click="del_enquate(index)" class="btn btn-danger">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </div>
          <div class="col-1">
            <div class="d-grid">
              <button @click="del_enquate(index)" class="btn btn-danger">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </div>
          <div
            class="col-2 mt-2"
            v-if="enquate.enquate_type == 300 || enquate.enquate_type == 400"
          >
            <div class="d-grid">
              <button
                @click="add_option(index)"
                class="btn btn-sm btn-light btn-outline-secondary"
              >
                <i class="bi bi-plus"></i>&nbsp;選択肢追加
              </button>
            </div>
          </div>
          <div
            class="col-10 mt-2"
            v-if="enquate.enquate_type == 300 || enquate.enquate_type == 400"
          >
            <div
              class="row mb-1"
              v-for="(option, op_index) in enquate.options"
              :key="option"
            >
              <div class="col-1">
                {{ op_index + 1 }}
              </div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="option.label"
                  class="form-control form-control-sm"
                />
              </div>
              <div class="col-2">
                <input
                  type="number"
                  v-model="option.sort"
                  class="form-control form-control-sm"
                />
              </div>
              <div class="col-2">
                <div class="d-grid">
                  <button
                    @click="del_option(index, op_index)"
                    class="btn btn-sm btn-danger"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="position-sticky bottom-0 bg-light pt-3 pb-2 px-2 border rounded-1"
      style="z-index: 110"
    >
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-if="chk_relation_type_editable('/master/list')"
        >
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import '../../assets/bootstrap/css/sc.css';
import axios from 'axios'
import config from '../../../const'

export default {
  name: 'EnquateDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: 'アンケートデータ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      enquate_sheet_obj: {},
      enquate_type_obj: [],
      enquate_type_label_obj: [],
      default_enquate_obj: {
        id: 0,
        stat: 1,
        sheet_id: this.$route.params.id,
        enquate_type: 0,
        label: '',
        options: []
      },
      default_enquate_option_obj: {
        id: 0,
        stat: 1,
        enquate_id: 0,
        test_id: 0,
        label: '',
        correct: 0
      }
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    async add_enquate() {
      const tmps = { ...this.default_enquate_obj }
      const sheet_obj = { ...this.enquate_sheet_obj }

      // enquate_dataが未定義の場合は空配列で初期化
      if (!sheet_obj.enquate_data) {
        sheet_obj.enquate_data = []
      }

      const enquate_data = [...sheet_obj.enquate_data]
      // sortの設定
      tmps.sort = enquate_data.length + 1

      enquate_data.push({ ...tmps })
      sheet_obj.enquate_data = enquate_data
      this.enquate_sheet_obj = sheet_obj
    },
    async del_enquate(enq_index) {
      const enquate_data = [...this.enquate_sheet_obj.enquate_data]
      if (enquate_data[enq_index]) {
        enquate_data.splice(enq_index, 1)
      }
      this.enquate_sheet_obj.enquate_data = enquate_data
    },
    async add_option(enq_index) {
      const optmps = { ...this.default_enquate_option_obj }
      const sheet_obj = { ...this.enquate_sheet_obj }
      const enquate_data = [...sheet_obj.enquate_data]
      const target_enquate_data = enquate_data[enq_index]

      // 親のenquate_idを設定
      optmps.enquate_id = String(target_enquate_data.id || 0)

      // sortの設定
      const currentOptions = target_enquate_data.options || []
      optmps.sort = currentOptions.length + 1

      if (!target_enquate_data.options) {
        target_enquate_data.options = []
      }

      // optionsが未定義の場合は初期化
      if (!target_enquate_data.options) {
        target_enquate_data.options = []
      }

      const target_options = [...target_enquate_data.options]
      target_options.push({ ...optmps })
      target_enquate_data.options = target_options
      enquate_data[enq_index] = target_enquate_data
      sheet_obj.enquate_data = enquate_data
      this.enquate_sheet_obj = sheet_obj
    },
    async del_option(enq_index, option_index) {
      const sheet_obj = { ...this.enquate_sheet_obj }
      const enquate_data = [...sheet_obj.enquate_data]
      if (enquate_data[enq_index]) {
        if (
          typeof enquate_data[enq_index].options === 'object' &&
          typeof enquate_data[enq_index].options[option_index] === 'object'
        ) {
          enquate_data[enq_index].options.splice(option_index, 1)
        }
      }
      sheet_obj.enquate_data = enquate_data
      this.enquate_sheet_obj = sheet_obj
    },
    /**
     * マスタデータ読み込み
     * @param {string} param - 設定種別
     */
    async loadConfigObj(param) {
      try {
        const response = await this.basicPosts_S(
          `${config.BASE_API_URL}/config/${param}`,
          {}
        )
        this[`${param}_obj`] = response.data?.body || []
      } catch (err) {
        console.error(`Error loading ${param}:`, err)
        this[`${param}_obj`] = []
      } finally {
        this.$forceUpdate()
      }
    },
    async loadEnquateSheetObj() {
      const params = {}
      params['id'] = this.targetid
      await axios
        .post(
          config.BASE_API_URL + '/enquate_sheet/lists',
          this.setParams_S(params),
          this.cHeader
        )
        .then(async response => {
          console.log('loadEnquateSheetObj', response)
          this.enquate_sheet_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.enquate_sheet_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async update() {
      const params = this.enquate_sheet_obj
      // enquate_dataの各optionsのenquate_idを維持
      if (params.enquate_data) {
        params.enquate_data.forEach(enquate => {
          if (enquate.options) {
            enquate.options.forEach(option => {
              option.enquate_id = String(enquate.id)
            })
          }
        })
      }
      console.log('update params', params)
      const post_url = this.not_add
        ? config.BASE_API_URL + '/enquate_sheet/edit/' + this.targetid
        : config.BASE_API_URL + '/enquate_sheet/add'
      let result = true
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          console.log('update enquate_sheet response', response)
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.alertMessage = this.btnLabel + 'しました'
            this.alertClass = 'alert-success'
            this.targetid = response.data.body.id
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
            if (typeof response.data.alert.error_obj === 'object') {
              const tmp_error = { ...this.member_error_obj }
              Object.keys(response.data.alert.error_obj).forEach(key => {
                tmp_error[key] = response.data.alert.error_obj[key]
              })
              this.race_series_obj = tmp_error
            }
          } else {
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          if (result) await this.loadEnquateSheetObj()
          this.$forceUpdate()
          alert(this.alertMessage + ':' + result + ':' + this.targetid)
        })
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({}),
    not_add: function () {
      return this.targetid != 'add' && !Number.isNaN(this.targetid)
        ? true
        : false
    },
    attach_obj: function () {
      const series_obj = this.race_series_obj
      return function (target_id, type) {
        const target_column = type == 'type' ? 'race_type_id' : 'class_id'
        if (
          typeof series_obj === 'object' &&
          typeof series_obj[type + '_relation'] === 'object' &&
          series_obj[type + '_relation'].find(
            relation => relation[target_column] == target_id
          )
        ) {
          return true
        }
        return false
      }
    },
    attach_obj_class: function () {
      const attach = this.attach_obj
      return function (target_id, type) {
        if (attach(target_id, type)) {
          return 'btn btn-sm btn-primary'
        }
        return 'btn btn-sm btn-dark'
      }
    },
    attach_target_license: function () {
      const add_price = (this.race_series_obj || {}).add_price
      return function (target_id) {
        if (
          typeof add_price === 'object' &&
          add_price.find(obj => obj.target_id == target_id)
        ) {
          return add_price.find(obj => obj.target_id == target_id)
        }
        return false
      }
    },
    attach_target_license_stat: function () {
      const attach = this.attach_target_license
      return function (target_id) {
        const obj = attach(target_id)
        if (typeof obj === 'object') {
          return parseInt((obj || {}).stat)
        }
        return false
      }
    },
    attach_target_license_price: function () {
      const attach = this.attach_target_license
      return function (target_id) {
        const obj = attach(target_id)
        if (typeof obj === 'object') {
          return parseInt((obj || {}).price)
        }
        return false
      }
    },
    chk_license_from_class: function () {
      const lists = [...this.race_series_list_obj]
      return function (license_class) {
        if (lists.find(list => list.license_class == license_class)) {
          return true
        }
        return false
      }
    },
    enquate_type_list: function () {
      return this.enquate_type_obj
    },
    enquate_type_label_list: function () {
      return this.enquate_type_label_obj
    }
  },

  async created() {
    await this.loadConfigObj('enquate_type')
    await this.loadConfigObj('enquate_type_label')
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadEnquateSheetObj()
      this.btnLabel = '更新'
    } else {
      this.enquate_sheet_obj = {
        id: 0,
        label: '',
        sort: '',
        enquate_data: []
      }
      this.btnLabel = '登録'
      await this.loadEnquateSheetObj()
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = 'アンケートデータ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
